import i18n from '../i18n';

export default function translate(key, defaultValue = '') {
  const translatedText = i18n.t(key);
  if (translatedText === key) {
    return defaultValue;
  }
  return translatedText;
}

